import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import useCurrentShop from '../../../hooks/useCurrentShop'
import styles from './SingleOccupancyCard.module.scss'

Single.propTypes = {
  sharedHandler: PropTypes.func.isRequired,
  setIsCollapsed: PropTypes.func.isRequired,
  isApplySingle: PropTypes.bool,
  priceSection: PropTypes.node,
}

export default function Single({
  sharedHandler,
  setIsCollapsed,
  isApplySingle,
  priceSection,
}) {
  const { shopInfo: { id } } = useCurrentShop()
  return (
    <div className={styles.inner}>
      {isApplySingle && (
        <div className={styles.body}>
          <FormattedMessage
            id='room_is_no_sharable'
            defaultMessage='The cabin you have selected only {doubleBed}is not shareable. By default, we have therefore applied the price for SINGLE OCCUPANCY. This means that you will have the cabin to yourself.'
            tagName='p'
            values={{
              doubleBed: id === '17034' ? '' : 'has a double bed and ',
            }}
          />
          <FormattedMessage
            id='return_to_step_2_for_change_cabin'
            defaultMessage='If this is not what you wanted, please go back to step 2 and select a different cabin'
            tagName='p'
          />
        </div>
      )}
      {priceSection}
      {!isApplySingle && (
        <div className={styles.actions}>
          <button
            type='button'
            className={styles.btnPrimary}
            onClick={() => sharedHandler(true)}
          >
            <FormattedMessage
              id='want_to_share'
              defaultMessage='Yes I want to share the cabin'
            />
          </button>
          <button
            type='button'
            className={styles.btnSecondary}
            onClick={() => setIsCollapsed(true)}
          >
            <FormattedMessage
              id='stay_with_single_occupancy'
              defaultMessage="No thanks, I'm happy with single occupancy"
            />
          </button>
        </div>
      )}
    </div>
  )
}
